import { useEffect } from "react";
import { useLang } from "../LangContext";
import { useSupabaseAuth } from "../SupabaseAuthContext";
import { supabase } from "../lib/supabaseClient";

const LANG_KEY = "6amico_lang";
const EXPLICIT_KEY = "6amico_lang_explicit";

function hasExplicitChoice() {
  try {
    return localStorage.getItem(EXPLICIT_KEY) === "1" && !!localStorage.getItem(LANG_KEY);
  } catch {
    return false;
  }
}

/**
 * Sync lingua ↔ profilo Supabase.
 * Profilo → dispositivo: applica preferred_language solo se su questo
 * dispositivo non c'è ancora una scelta esplicita (altrimenti il default
 * 'it' del profilo annullerebbe il click appena fatto sullo switcher).
 * Dispositivo → profilo: una scelta manuale viene salvata sul profilo,
 * così segue l'utente sugli altri dispositivi.
 */
export default function LangSupabaseSync() {
  const { profile, session } = useSupabaseAuth();
  const { lang, setLang } = useLang();

  useEffect(() => {
    if (hasExplicitChoice()) return;
    const pl = profile?.preferred_language;
    if (!pl || typeof pl !== "string") return;
    const code = pl.split("-")[0].toLowerCase();
    if (code && code !== lang) setLang(code);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profile?.preferred_language]);

  useEffect(() => {
    const uid = session?.user?.id;
    if (!uid || !supabase) return;
    if (!hasExplicitChoice()) return;
    if (!lang || profile?.preferred_language === lang) return;
    supabase
      .from("profiles")
      .update({ preferred_language: lang })
      .eq("id", uid)
      .then(({ error }) => {
        if (error) console.warn("preferred_language sync:", error.message);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lang, session?.user?.id]);

  return null;
}
